import React from 'react';
import { usePermissions } from '@/hooks/usePermissions';

interface ReportPermissionGateProps {
  reportId: string;
  action?: string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
  showFallback?: boolean;
}

/**
 * Component that conditionally renders children based on report permissions
 */
const ReportPermissionGate: React.FC<ReportPermissionGateProps> = ({
  reportId,
  action,
  children,
  fallback = null,
  showFallback = true,
}) => {
  const { canAccessReport, canPerformAction } = usePermissions();

  // Check if user can access the report
  if (!canAccessReport(reportId)) {
    return showFallback ? (fallback ?? null) : null;
  }

  // If specific action is required, check if user can perform it
  if (action && !canPerformAction(reportId, action)) {
    return showFallback ? (fallback ?? null) : null;
  }

  return <>{children}</>;
};

export default ReportPermissionGate;
